import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ValidateEventUrlResponse } from "../schema/liEvent";

interface EventUrlPreviewCardProps {
	validationResult: ValidateEventUrlResponse;
}

export const EventUrlPreviewCard: FunctionComponent<EventUrlPreviewCardProps> = ({
	validationResult,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`liEvent.${key}`);

	return (
		<div className="mt-3 p-4 rounded-lg border border-border-light bg-brand-white">
			<div className="text-sm font-semibold text-text mb-3">{ts("eventPreview")}</div>
			<div className="grid grid-cols-[1fr_2fr] gap-x-4 gap-y-2 text-sm">
				{validationResult.title && (
					<>
						<span className="text-text-meta">{ts("eventTitle")}</span>
						<span className="text-text">{validationResult.title}</span>
					</>
				)}
				{validationResult.companyName && (
					<>
						<span className="text-text-meta">{ts("eventCompany")}</span>
						<span className="text-text">{validationResult.companyName}</span>
					</>
				)}
				{validationResult.eventAt && (
					<>
						<span className="text-text-meta">{ts("eventDate")}</span>
						<span className="text-text">
							{new Date(validationResult.eventAt).toLocaleDateString()}
						</span>
					</>
				)}
				{validationResult.urn && (
					<>
						<span className="text-text-meta">{ts("eventUrn")}</span>
						<span className="text-text">{validationResult.urn}</span>
					</>
				)}
			</div>
			{validationResult.description && (
				<div className="mt-3 pt-3 border-t border-border-light">
					<span className="text-text-meta text-sm">{ts("eventDescription")}</span>
					<p className="text-text text-sm mt-1 line-clamp-3">{validationResult.description}</p>
				</div>
			)}
		</div>
	);
};
